// extracted by mini-css-extract-plugin
export default {"errorWrapper":"ErrorMessage_errorWrapper__0LqOE"};